"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ui = require("@alycecom/ui");

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ramda = require("ramda");

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    container: {
      maxHeight: '350px'
    },
    paper: {
      minWidth: '516px'
    }
  };
});

var DeleteDefaultTemplateConfirmation = function DeleteDefaultTemplateConfirmation(_ref) {
  var isOpen = _ref.isOpen,
      allGiftInvitationTemplates = _ref.allGiftInvitationTemplates,
      onSubmit = _ref.onSubmit,
      onDiscard = _ref.onDiscard;
  var classes = useStyles();
  var elements = allGiftInvitationTemplates.map((0, _ramda.prop)('name')).join(', ');
  return /*#__PURE__*/_react.default.createElement(_ui.ModalConfirmationMessage, {
    variant: "warning",
    isOpen: isOpen,
    title: "This is a default template",
    submitButtonText: "Delete",
    cancelButtonText: "Cancel",
    onSubmit: onSubmit,
    onDiscard: onDiscard,
    icon: "trash",
    width: "100%",
    DialogProps: {
      classes: {
        paper: classes.paper
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.container
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: {
      mb: 4
    }
  }, "If you choose to delete this template, it will still be set as the default for the following", ' ', allGiftInvitationTemplates.length > 1 ? 'campaigns' : 'campaign', ": ", elements, "."), /*#__PURE__*/_react.default.createElement(_material.Typography, null, "If you wish to assign a different default template, please navigate to the Campaigns page.")));
};

var _default = DeleteDefaultTemplateConfirmation;
exports.default = _default;